module.exports = __webpack_public_path__ + "static/media/iconInvoiceActive.48e47965.svg";